<template>
    <transition
            @after-enter="itemAfterEnter"
            @enter="itemEnter"
            @leave="itemLeave"
            name="c-expand-transition">
        <slot></slot>
    </transition>
</template>

<script>
    import TransitionExpand from '../../mixins/transition-expand.vue'

    export default {
        name: 'base-transition-expand',
        mixins: [TransitionExpand],
    };
</script>

<style lang="scss" scoped>
    // Transition Smoothness
    * {
        will-change: height;
        /*transform: translateZ(0);*/
        backface-visibility: hidden;
        /*perspective: 1000px;*/
    }
</style>
